import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo/Seo";
import { Reveal } from "@/components/Reveal/Reveal";
import { FAQS } from "@/data/content";
import { faqJsonLd, breadcrumbJsonLd } from "@/lib/structuredData";
import styles from "./Faq.module.css";

export function FaqPage() {
  return (
    <>
      <Seo
        title="FAQ"
        description="Frequently asked questions about staying at and hosting events at Villa Rosa — amenities, capacity, check-in, accessibility, and booking."
        path="/faq"
        jsonLd={[
          faqJsonLd(FAQS),
          breadcrumbJsonLd([
            { name: "Home", path: "/" },
            { name: "FAQ", path: "/faq" },
          ]),
        ]}
      />

      <header className={styles.head}>
        <div className="container">
          <p className="eyebrow eyebrow--rule">Frequently Asked Questions</p>
          <h1>Everything you need to know</h1>
          <p className={styles.lede}>
            Answers to the questions guests ask most. Still curious? We're happy
            to help.
          </p>
        </div>
      </header>

      <section className="section">
        <div className={`container ${styles.wrap}`}>
          <div className={styles.list}>
            {FAQS.map((item, i) => (
              <Reveal as="details" key={item.q} variant="up" delay={(i % 5) * 50} className={styles.item}>
                <summary className={styles.summary}>
                  <span>{item.q}</span>
                  <span className={styles.icon} aria-hidden="true" />
                </summary>
                <div className={styles.answer}>
                  <p>{item.a}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal as="aside" variant="right" className={styles.cta}>
            <h3>Still have questions?</h3>
            <p>We'd love to help you plan your stay or event at Villa Rosa.</p>
            <Link to="/contact" className="btn btn--primary">
              Submit a question
            </Link>
            <div className={styles.ctaLinks}>
              <Link to="/book-a-stay">Book a stay →</Link>
              <Link to="/book-an-event">Book an event →</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
